// French translations
const fr = {
  siteName: 'Brothers Phone',
  common: {
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    search: 'Rechercher',
    back: 'Retour',
    yes: 'Oui',
    no: 'Non',
    add: 'Ajouter',
    remove: 'Retirer',
    submit: 'Soumettre',
    login: 'Connexion',
    logout: 'Déconnexion',
    register: 'S\'inscrire',
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    products: 'Produits',
    categories: 'Catégories',
    orders: 'Commandes',
    cart: 'Panier',
    wishlist: 'Liste de souhaits',
    addToCart: 'Ajouter au panier',
    addToWishlist: 'Ajouter aux favoris',
    viewMore: 'Voir plus',
    outOfStock: 'Rupture de stock',
    addedToCart: 'Produit ajouté au panier!',
    addedToWishlist: 'Produit ajouté aux favoris!',
    addToCartError: 'Échec de l\'ajout au panier',
    addToWishlistError: 'Échec de l\'ajout aux favoris',
    loginRequired: 'Veuillez vous connecter pour ajouter des articles à vos favoris',
    profile: 'Profil',
    settings: 'Paramètres',
    admin: 'Admin',
  },
  navigation: {
    home: 'Accueil',
    shop: 'Boutique',
    news: 'Nouveautés',
    about: 'À propos',
    contact: 'Contact',
    myAccount: 'Mon compte',
    admin: 'Tableau Admin',
    profile: 'Profil',
    orders: 'Commandes',
    wishlist: 'Liste de souhaits',
    cart: 'Panier',
    login: 'Connexion',
    register: 'S\'inscrire',
    logout: 'Déconnexion',
  },
  auth: {
    username: 'Nom d\'utilisateur',
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    forgotPassword: 'Mot de passe oublié?',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    dontHaveAccount: 'Vous n\'avez pas de compte?',
    loginSuccessful: 'Connexion réussie!',
    registrationSuccessful: 'Inscription réussie!',
    logoutSuccessful: 'Vous avez été déconnecté.',
    invalidCredentials: 'Identifiants invalides.',
    unauthorizedAccess: 'Accès non autorisé.',
    sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
  },
  products: {
    title: 'Produits',
    addToCart: 'Ajouter au panier',
    addToWishlist: 'Ajouter aux favoris',
    outOfStock: 'Rupture de stock',
    inStock: 'En stock',
    price: 'Prix',
    quantity: 'Quantité',
    description: 'Description',
    name: 'Nom',
    category: 'Catégorie',
    searchPlaceholder: 'Rechercher des produits...',
    filter: 'Filtrer',
    sort: 'Trier',
    noProductsFound: 'Aucun produit trouvé.',
    createNew: 'Créer un nouveau produit',
    edit: 'Modifier le produit',
    delete: 'Supprimer le produit',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer ce produit?',
  },
  cart: {
    title: 'Panier',
    empty: 'Votre panier est vide.',
    continueShipping: 'Continuer les achats',
    subtotal: 'Sous-total',
    total: 'Total',
    checkout: 'Commander',
    removeFromCart: 'Retirer du panier',
    updateQuantity: 'Mettre à jour la quantité',
    itemAdded: 'Article ajouté au panier!',
    itemRemoved: 'Article retiré du panier!',
    itemUpdated: 'Panier mis à jour!',
  },
  orders: {
    title: 'Commandes',
    orderNumber: 'Numéro de commande',
    date: 'Date',
    status: 'Statut',
    total: 'Total',
    details: 'Voir les détails',
    noOrdersFound: 'Aucune commande trouvée.',
    createNew: 'Créer une nouvelle commande',
    placeOrder: 'Passer la commande',
    orderPlaced: 'Commande passée avec succès!',
    orderCancelled: 'Commande annulée!',
    cancelOrder: 'Annuler la commande',
    pending: 'En attente',
    processing: 'En traitement',
    shipped: 'Expédiée',
    delivered: 'Livrée',
    cancelled: 'Annulée',
  },
  news: {
    title: 'Dernières Nouveautés',
    subtitle: 'Restez informé de nos derniers produits et annonces',
    featuredImage: 'Image Vedette',
    logoAnimation: 'Notre Marque',
    socialMedia: 'Suivez-Nous',
    youtubeVideos: 'Dernières Vidéos',
    noContent: 'Aucun contenu d\'actualité disponible pour le moment.',
    managePage: 'Gérer la Page Nouveautés',
    updateContent: 'Mettre à Jour le Contenu',
    uploadImage: 'Télécharger une Image',
    addVideo: 'Ajouter une Vidéo YouTube',
    videoUrl: 'URL de la Vidéo YouTube',
    socialLinks: 'Liens des Réseaux Sociaux',
    facebook: 'Facebook',
    instagram: 'Instagram',
    twitter: 'Twitter',
    youtube: 'YouTube',
    tiktok: 'TikTok',
  },
  footer: {
    about: 'À propos',
    contact: 'Contact',
    terms: 'Conditions d\'utilisation',
    privacy: 'Politique de confidentialité',
    copyright: '© 2025 Brothers Phone. Tous droits réservés.',
  },
};

export default fr;
